import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { HomeRegimesFailure, HomeRegimesRequest, HomeRegimesSuccess } from './actions';
import { HomeRegimesService } from './service';
import { AppState } from '@store/app.state';
import { select, Store } from '@ngrx/store';
import { getData } from './selectors';

@Injectable()
export class HomeRegimesEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly homeRegimesService = inject(HomeRegimesService);

  homeRegimes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HomeRegimesRequest),
      withLatestFrom(this.store.pipe(select(getData))),
      switchMap(([{ parameters }, data]) => {
        if (!data?.length) {
          return this.homeRegimesService.homeRegimes(parameters).pipe(
            map(data => HomeRegimesSuccess({ data })),
            catchError(error => of(HomeRegimesFailure({ error })))
          );
        }
        return of(HomeRegimesSuccess({ data }));
      })
    )
  );

}
